export const ADMIN_USER_TYPE = [
  { value: 'true', label: 'Admin' },
  { value: 'false', label: 'Staff' },
];

export const ADMIN_USER_ACTIVE_TYPE = [
  { value: 'true', label: 'Active' },
  { value: 'false', label: 'Inactive' },
];
